import { formatInteger } from "@/utils/currency";
import React from "react";

interface UserProgressBarProps {
  totalCreditsUsed: number;
  includedCredits: number;
  className?: string;
}

export const UserProgressBar: React.FC<UserProgressBarProps> = ({
  totalCreditsUsed,
  includedCredits,
  className = "",
}) => {
  // Only show individual included credit usage (no on-demand per user)
  const includedUsage = Math.min(totalCreditsUsed, includedCredits);
  const includedPercentage =
    includedCredits > 0 ? (includedUsage / includedCredits) * 100 : 0;

  return (
    <div className={`space-y-1 ${className}`}>
      {/* Mini progress bar - only shows included credit usage */}
      <div className="relative h-2 w-full overflow-hidden rounded-full bg-neutral-200 dark:bg-neutral-700">
        <div
          className="absolute left-0 top-0 h-full bg-lc-active transition-all duration-300"
          style={{ width: `${includedPercentage}%` }}
        />
      </div>

      {/* Usage summary - only shows included credits */}
      <div className="flex items-center justify-between text-xs text-muted-foreground">
        <span>
          {formatInteger(totalCreditsUsed)} / {formatInteger(includedCredits)}{" "}
          credits
        </span>
        {totalCreditsUsed > includedCredits && (
          <span className="text-neutral-600 dark:text-neutral-400 font-medium">
            Over included limit
          </span>
        )}
      </div>
    </div>
  );
};
